import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBaseProperties } from "../base";
import { Product } from "../products/product";
export const DeliveryNoteItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      amount: types.maybeNull(types.number),
      weight: types.maybeNull(types.number),
      mh: types.maybeNull(types.number),
      package: types.maybeNull(types.number),
      note: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IDeliveryNoteItem extends Instance<typeof DeliveryNoteItem> {}
export interface IDeliveryNoteItemProperties
  extends SnapshotIn<typeof DeliveryNoteItem> {}

export interface IAddDeliveryNoteItem
  extends Omit<
    IDeliveryNoteItemProperties,
    "product" | keyof IBaseProperties
  > {}
export interface IUpdateDeliveryNoteItem
  extends Omit<IDeliveryNoteItemProperties, "product"> {}
